import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import { alert, Input, Button, Page } from 'equasion-lib';
import {
  requestResetValidation,
  requestResetDefaults,
  resetValidation,
  resetDefaults
} from './ForgotPassword.validation';
import './ForgotPassword.scss';

function ForgotPassword({ resetPassword, requestPasswordReset }) {
  const navigate = useNavigate();
  const token = new URL(window.location.href).searchParams.get('token');

  const submitRequestPasswordReset = async (data, actions) => {
    const { setSubmitting } = actions;

    try {
      await requestPasswordReset({
        variables: data
      });
      alert(
        'Password Reset Success',
        'If your username is registered with us, you will be receiving a password reset email.',
        4,
        'success'
      );
    } catch {}

    setSubmitting(false);
  };

  const resetPasswordClicked = async (data, actions) => {
    const { setSubmitting } = actions;

    try {
      await resetPassword({
        variables: {
          resetPasswordAttributes: { ...data, token }
        }
      });
      alert('Password Reset Success', 'Your password has been reset.', 4, 'success');
      navigate('/');
    } catch {}

    setSubmitting(false);
  };

  return (
    <Page className="reset-password">
      {token ? (
        <>
          <h2>Password Reset</h2>
          <Formik
            validationSchema={resetValidation}
            initialValues={resetDefaults}
            onSubmit={resetPasswordClicked}
          >
            {({ isSubmitting }) => (
              <Form>
                <Input
                  name="password"
                  type="password"
                  autoComplete="password"
                  label="New Password"
                />

                <Input
                  name="confirmPassword"
                  type="password"
                  autoComplete="password"
                  label="Confirm New Password"
                />

                <Button
                  type="primary"
                  isSubmit
                  disabled={isSubmitting}
                  className="submit-button"
                >
                  Save Password
                </Button>
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <>
          <h2>Forgot Password</h2>
          <Formik
            validationSchema={requestResetValidation}
            initialValues={requestResetDefaults}
            onSubmit={submitRequestPasswordReset}
          >
            {({ isSubmitting }) => (
              <Form>
                <Input
                  name="username"
                  type="username"
                  autoComplete="username"
                  label="Username"
                />

                <Button
                  type="primary"
                  isSubmit
                  disabled={isSubmitting}
                  className="submit-button"
                >
                  Reset Password
                </Button>
              </Form>
            )}
          </Formik>
        </>
      )}
      <Link className="nav-link" to="/">
        <Button type="link">Sign In</Button>
      </Link>
    </Page>
  );
}

export default ForgotPassword;
